

const urlStore = {
  state: {
    url: (localStorage.getItem('url'))? localStorage.getItem('url'):process.env.VUE_APP_API_URL // read from localstorage
  },
  actions: {
    setURL (context, url) {
      context.commit('setURL', url)
    },
  },
  mutations: {
    setURL (state, url) {
      state.url = url
      localStorage.setItem('url', url)
      // add to localstorage
    }
  }
}

export default urlStore
